import { safeJSONparse } from "./safeJSONparse";

export const FEATURE_ENABLE_CACHING: string = "FEATURE_ENABLE_CACHING";
export const FEATURE_CAN_USE_MANUAL_QUERY: string = "FEATURE_CAN_USE_MANUAL_QUERY";
export const FEATURE_CAN_USE_COMPANY_SEARCH: string = "FEATURE_CAN_USE_COMPANY_SEARCH";
export const FEATURE_CAN_USE_COMMUNICATION_FEED: string = "FEATURE_CAN_USE_COMMUNICATION_FEED";
export const FEATURE_CAN_USE_RELATIONS: string = "FEATURE_CAN_USE_RELATIONS";
export const FEATURE_CAN_SEE_ORGANISATIONS: string = "FEATURE_CAN_SEE_ORGANISATIONS";
export const FEATURE_DASHBOARD: string = "FEATURE_DASHBOARD";
export const FEATURE_ADDONS: string = "FEATURE_ADDONS";
export const FEATURE_FLOWS: string = "FEATURE_FLOWS";
export const FEATURE_TASKS: string = "FEATURE_TASKS";
export const FEATURE_API_KEYS: string = "FEATURE_API_KEYS";
export const FEATURE_DEV_PORTAL: string = "FEATURE_DEV_PORTAL";
export const FEATURE_CAN_SEE_USERS: string = 'FEATURE_CAN_SEE_USERS';

const allFlags: string[] = [
    FEATURE_CAN_USE_COMPANY_SEARCH,
    FEATURE_FLOWS,
    FEATURE_CAN_SEE_USERS,
];

export function hasFeatureFlag(perm: string, user: any): boolean {
    if (allFlags.indexOf(perm) !== -1) {
        return true;
    }

	let hasPermission: boolean = false;
	if (user && user.featureFlags) {
		hasPermission = isPermInFeatureFlags(perm, user.featureFlags);

		if (!hasPermission && user.organisation && user.organisation.featureFlags) {
			hasPermission = isPermInFeatureFlags(perm, user.organisation.featureFlags);
		}
	}

	return hasPermission;
}

function isPermInFeatureFlags(perm: string, featureFlags: string | any[]): boolean {
	if (typeof featureFlags === "string") {
		featureFlags = safeJSONparse(featureFlags);
	}
	if (Array.isArray(featureFlags) && featureFlags.indexOf(perm) !== -1) {
		return true;
	}

	return false;
}